import SubscriptionSettings from './SubscriptionSettings'
export default SubscriptionSettings
